"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Stargate Internal
 * Invitae API for internal apps
 *
 * The version of the OpenAPI document: 11.19.2
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CombiRplReasonForTestingDtoToJSON = exports.CombiRplReasonForTestingDtoFromJSONTyped = exports.CombiRplReasonForTestingDtoFromJSON = exports.instanceOfCombiRplReasonForTestingDto = exports.CombiRplReasonForTestingDtoSpermCountResultEnum = void 0;
var runtime_1 = require("../runtime");
/**
 * @export
 */
exports.CombiRplReasonForTestingDtoSpermCountResultEnum = {
    Normal: 'Normal',
    ResultsPending: 'Results pending',
    AzoospermiaNonObstructive: 'Azoospermia: non-obstructive',
    AzoospermiaObstructive: 'Azoospermia: obstructive',
    AzoospermiaUnknown: 'Azoospermia: unknown',
    Abnormal: 'Abnormal',
    Other: 'Other'
};
/**
 * Check if a given object implements the CombiRplReasonForTestingDto interface.
 */
function instanceOfCombiRplReasonForTestingDto(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCombiRplReasonForTestingDto = instanceOfCombiRplReasonForTestingDto;
function CombiRplReasonForTestingDtoFromJSON(json) {
    return CombiRplReasonForTestingDtoFromJSONTyped(json, false);
}
exports.CombiRplReasonForTestingDtoFromJSON = CombiRplReasonForTestingDtoFromJSON;
function CombiRplReasonForTestingDtoFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'isFemaleInfertility': !(0, runtime_1.exists)(json, 'isFemaleInfertility') ? undefined : json['isFemaleInfertility'],
        'isRecurrentPregnancyLoss': !(0, runtime_1.exists)(json, 'isRecurrentPregnancyLoss') ? undefined : json['isRecurrentPregnancyLoss'],
        'isMaleInfertility': !(0, runtime_1.exists)(json, 'isMaleInfertility') ? undefined : json['isMaleInfertility'],
        'isMalePartnerRecurrentPregnancyLoss': !(0, runtime_1.exists)(json, 'isMalePartnerRecurrentPregnancyLoss') ? undefined : json['isMalePartnerRecurrentPregnancyLoss'],
        'isSuspectedChromosomeAbnormality': !(0, runtime_1.exists)(json, 'isSuspectedChromosomeAbnormality') ? undefined : json['isSuspectedChromosomeAbnormality'],
        'isOtherIndicationReason': !(0, runtime_1.exists)(json, 'isOtherIndicationReason') ? undefined : json['isOtherIndicationReason'],
        'otherIndicationReason': !(0, runtime_1.exists)(json, 'otherIndicationReason') ? undefined : json['otherIndicationReason'],
        'hasSuggestivePgtResults': !(0, runtime_1.exists)(json, 'hasSuggestivePgtResults') ? undefined : json['hasSuggestivePgtResults'],
        'patientHadASemenAnalysis': !(0, runtime_1.exists)(json, 'patientHadASemenAnalysis') ? undefined : json['patientHadASemenAnalysis'],
        'pgtResultsInvitaeOrderId': !(0, runtime_1.exists)(json, 'pgtResultsInvitaeOrderId') ? undefined : json['pgtResultsInvitaeOrderId'],
        'spermCountResult': !(0, runtime_1.exists)(json, 'spermCountResult') ? undefined : json['spermCountResult'],
        'spermCountResultOther': !(0, runtime_1.exists)(json, 'spermCountResultOther') ? undefined : json['spermCountResultOther'],
        'additionalClinHistory': !(0, runtime_1.exists)(json, 'additionalClinHistory') ? undefined : json['additionalClinHistory'],
    };
}
exports.CombiRplReasonForTestingDtoFromJSONTyped = CombiRplReasonForTestingDtoFromJSONTyped;
function CombiRplReasonForTestingDtoToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'isFemaleInfertility': value.isFemaleInfertility,
        'isRecurrentPregnancyLoss': value.isRecurrentPregnancyLoss,
        'isMaleInfertility': value.isMaleInfertility,
        'isMalePartnerRecurrentPregnancyLoss': value.isMalePartnerRecurrentPregnancyLoss,
        'isSuspectedChromosomeAbnormality': value.isSuspectedChromosomeAbnormality,
        'isOtherIndicationReason': value.isOtherIndicationReason,
        'otherIndicationReason': value.otherIndicationReason,
        'hasSuggestivePgtResults': value.hasSuggestivePgtResults,
        'patientHadASemenAnalysis': value.patientHadASemenAnalysis,
        'pgtResultsInvitaeOrderId': value.pgtResultsInvitaeOrderId,
        'spermCountResult': value.spermCountResult,
        'spermCountResultOther': value.spermCountResultOther,
        'additionalClinHistory': value.additionalClinHistory,
    };
}
exports.CombiRplReasonForTestingDtoToJSON = CombiRplReasonForTestingDtoToJSON;
